import Alpine from 'alpinejs';
import { parseDate } from '../utils/dateUtils';

export default function registerCalendarSettingsReportsStore() {
  const existing = Alpine.store('calendarSettingsReportsStore');
  if (existing) return existing;

  return Alpine.store('calendarSettingsReportsStore', {
    calendarId: null,
    userPermission: null,
    bookingMode: 'RO',
    previousBookingMode: 'RO',
    invoicexpressEnabled: false,

    activeReportTab: 'financial',
    financialReport: {
      loading: false,
      data: [],
      total_amount: '0',
      filters: {
        date_from: '',
        date_to: '',
        partner_id: '',
        booking_status: '',
        transaction_type_id: '',
      },
    },
    partnerReport: {
      loading: false,
      data: [],
      selectedBookings: [],
      total_booking_amount: '0',
      total_partner_commission: '0',
      total_partner_invoice_amount: '0',
      filters: {
        date_from: '',
        date_to: '',
        date_filter_type: 'start_date',
        partner_id: '',
        booking_status: '',
        invoiced: '',
      },
      bulkInvoiceTaskId: null,
      bundleTaskId: null,
      bundleStatus: null,
      bundlePollingInterval: null,
      invoiceType: 'simple',
    },
    customerReport: {
      loading: false,
      data: [],
      total_count: 0,
      custom_field_columns: [],
      filters: {
        date_from: '',
        date_to: '',
        partner_id: '',
        country: '',
        custom_field_ids: [],
      },
    },
    reportExport: {
      jobId: null,
      status: null,
      progressMessage: '',
      polling: false,
      error: null,
      fileName: null,
    },
    financialReportFlatpickrInstance: null,
    partnerReportFlatpickrInstance: null,
    customerReportFlatpickrInstance: null,
    reportsSTATUS_DISPLAY: {
      PENDING: 'Pending',
      CONFIRMED_PART: 'Deposit',
      CONFIRMED: 'Confirmed',
      CANCELLED: 'Cancelled',
    },
    get STATUS_DISPLAY() {
      return this.reportsSTATUS_DISPLAY;
    },

    init() {
      this.initializeReportsSettings();
    },

    initializeSettingsContext() {
      const container = document.getElementById('calendarSettingsContainer');
      if (container) {
        this.calendarId = container.dataset.calendarId;
        this.userPermission = container.dataset.userPermission;
        this.bookingMode = container.dataset.bookingMode;
        this.previousBookingMode = container.dataset.bookingMode;
        this.invoicexpressEnabled =
          container.dataset.invoicexpressEnabled === 'true';
      }
    },

    initializeReportsSettings() {
      this.initializeSettingsContext();
    },

    getCsrfToken() {
      const input = document.querySelector('[name=csrfmiddlewaretoken]');
      return input ? input.value : '';
    },

    initFinancialReportDateRange(el) {
      if (typeof flatpickr === 'undefined') return;
      if (this.financialReportFlatpickrInstance) {
        this.financialReportFlatpickrInstance.destroy();
        this.financialReportFlatpickrInstance = null;
      }
      const self = this;
      const defaultDates = [];
      if (this.financialReport.filters.date_from)
        defaultDates.push(this.financialReport.filters.date_from);
      if (this.financialReport.filters.date_to)
        defaultDates.push(this.financialReport.filters.date_to);
      this.financialReportFlatpickrInstance = flatpickr(el, {
        mode: 'range',
        dateFormat: 'Y-m-d',
        showMonths: 2,
        altInput: true,
        altFormat: 'j M Y',
        defaultDate: defaultDates.length === 2 ? defaultDates : [],
        onChange(selectedDates) {
          if (selectedDates.length === 2) {
            self.financialReport.filters.date_from = selectedDates[0]
              .toISOString()
              .slice(0, 10);
            self.financialReport.filters.date_to = selectedDates[1]
              .toISOString()
              .slice(0, 10);
          } else if (selectedDates.length === 0) {
            self.financialReport.filters.date_from = '';
            self.financialReport.filters.date_to = '';
          }
        },
      });
    },

    initPartnerReportDateRange(el) {
      if (typeof flatpickr === 'undefined') return;
      if (this.partnerReportFlatpickrInstance) {
        this.partnerReportFlatpickrInstance.destroy();
        this.partnerReportFlatpickrInstance = null;
      }
      const self = this;
      const defaultDates = [];
      if (this.partnerReport.filters.date_from)
        defaultDates.push(this.partnerReport.filters.date_from);
      if (this.partnerReport.filters.date_to)
        defaultDates.push(this.partnerReport.filters.date_to);
      this.partnerReportFlatpickrInstance = flatpickr(el, {
        mode: 'range',
        dateFormat: 'Y-m-d',
        showMonths: 2,
        altInput: true,
        altFormat: 'j M Y',
        defaultDate: defaultDates.length === 2 ? defaultDates : [],
        onChange(selectedDates) {
          if (selectedDates.length === 2) {
            self.partnerReport.filters.date_from = selectedDates[0]
              .toISOString()
              .slice(0, 10);
            self.partnerReport.filters.date_to = selectedDates[1]
              .toISOString()
              .slice(0, 10);
          } else if (selectedDates.length === 0) {
            self.partnerReport.filters.date_from = '';
            self.partnerReport.filters.date_to = '';
          }
        },
      });
    },

    initCustomerReportDateRange(el) {
      if (typeof flatpickr === 'undefined') return;
      if (this.customerReportFlatpickrInstance) {
        this.customerReportFlatpickrInstance.destroy();
        this.customerReportFlatpickrInstance = null;
      }
      const self = this;
      const defaultDates = [];
      if (this.customerReport.filters.date_from)
        defaultDates.push(this.customerReport.filters.date_from);
      if (this.customerReport.filters.date_to)
        defaultDates.push(this.customerReport.filters.date_to);
      this.customerReportFlatpickrInstance = flatpickr(el, {
        mode: 'range',
        dateFormat: 'Y-m-d',
        showMonths: 2,
        altInput: true,
        altFormat: 'j M Y',
        defaultDate: defaultDates.length === 2 ? defaultDates : [],
        onChange(selectedDates) {
          if (selectedDates.length === 2) {
            self.customerReport.filters.date_from = selectedDates[0]
              .toISOString()
              .slice(0, 10);
            self.customerReport.filters.date_to = selectedDates[1]
              .toISOString()
              .slice(0, 10);
          } else if (selectedDates.length === 0) {
            self.customerReport.filters.date_from = '';
            self.customerReport.filters.date_to = '';
          }
        },
      });
    },

    async fetchFinancialReport() {
      this.financialReport.loading = true;
      try {
        const params = new URLSearchParams(this.financialReport.filters);
        const response = await fetch(
          `/reports/api/financial-report/?${params.toString()}`,
        );
        const result = await response.json();
        if (response.ok) {
          this.financialReport.data = result.transactions || [];
          this.financialReport.total_amount = result.total_amount || '0';
        } else {
          alert(
            'Error: ' + (result.error || 'Failed to fetch transaction report'),
          );
        }
      } catch (error) {
        alert('Error fetching transaction report: ' + error.message);
      } finally {
        this.financialReport.loading = false;
      }
    },

    async fetchPartnerReport() {
      this.partnerReport.loading = true;
      try {
        const params = new URLSearchParams(this.partnerReport.filters);
        const response = await fetch(
          `/reports/api/partner-report/?${params.toString()}`,
        );
        const result = await response.json();
        if (response.ok) {
          this.partnerReport.data = result.bookings || [];
          this.partnerReport.selectedBookings = [];
          this.partnerReport.total_booking_amount =
            result.total_booking_amount || '0.00';
          this.partnerReport.total_partner_commission =
            result.total_partner_commission || '0.00';
          this.partnerReport.total_partner_invoice_amount =
            result.total_partner_invoice_amount || '0.00';
        } else {
          alert('Error: ' + (result.error || 'Failed to fetch partner report'));
        }
      } catch (error) {
        alert('Error fetching partner report: ' + error.message);
      } finally {
        this.partnerReport.loading = false;
      }
    },

    async startReportExport(reportType, format) {
      this.reportExport.jobId = null;
      this.reportExport.status = 'starting';
      this.reportExport.progressMessage = 'Starting export...';
      this.reportExport.error = null;
      this.reportExport.fileName = null;

      let filters;
      if (reportType === 'financial') {
        filters = { ...this.financialReport.filters };
      } else if (reportType === 'customer') {
        filters = { ...this.customerReport.filters };
      } else {
        filters = { ...this.partnerReport.filters };
      }

      try {
        const response = await fetch('/reports/api/start-export/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.getCsrfToken(),
          },
          body: JSON.stringify({
            report_type: reportType,
            format,
            filters,
          }),
        });
        const result = await response.json();
        if (response.ok && result.job_id) {
          this.reportExport.jobId = result.job_id;
          this.reportExport.status = 'pending';
          this.pollReportExport();
        } else {
          this.reportExport.status = null;
          this.reportExport.progressMessage = '';
          alert('Error: ' + (result.error || 'Failed to start export'));
        }
      } catch (error) {
        this.reportExport.status = null;
        this.reportExport.progressMessage = '';
        alert('Error starting export: ' + error.message);
      }
    },

    async pollReportExport() {
      if (!this.reportExport.jobId) return;
      this.reportExport.polling = true;
      const check = async () => {
        try {
          const resp = await fetch(
            `/reports/api/export-status/${this.reportExport.jobId}/`,
          );
          const data = await resp.json();
          this.reportExport.status = data.status;
          this.reportExport.progressMessage = data.progress_message || '';
          if (data.status === 'completed') {
            this.reportExport.fileName = data.file_name;
            this.reportExport.polling = false;
            window.location.href = `/reports/api/export-download/${this.reportExport.jobId}/`;
            return;
          }
          if (data.status === 'failed') {
            this.reportExport.error = data.error || 'Export failed';
            this.reportExport.polling = false;
            alert('Export failed: ' + (data.error || 'Unknown error'));
            return;
          }
          setTimeout(() => check(), 1000);
        } catch (err) {
          this.reportExport.polling = false;
          this.reportExport.status = null;
          alert('Error checking export status: ' + err.message);
        }
      };
      check();
    },

    exportFinancialReport(format) {
      this.startReportExport('financial', format);
    },

    exportPartnerReport(format) {
      this.startReportExport('partner', format);
    },

    async fetchCustomerReport() {
      this.customerReport.loading = true;
      try {
        const params = new URLSearchParams();
        params.set('date_from', this.customerReport.filters.date_from);
        params.set('date_to', this.customerReport.filters.date_to);
        if (this.customerReport.filters.partner_id)
          params.set('partner_id', this.customerReport.filters.partner_id);
        if (this.customerReport.filters.country)
          params.set('country', this.customerReport.filters.country);
        (this.customerReport.filters.custom_field_ids || []).forEach((id) =>
          params.append('custom_field_ids', id),
        );
        const response = await fetch(
          `/reports/api/customer-report/?${params.toString()}`,
        );
        const result = await response.json();
        if (response.ok) {
          this.customerReport.data = result.customers || [];
          this.customerReport.total_count = result.total_count || 0;
          this.customerReport.custom_field_columns =
            result.custom_field_columns || [];
        } else {
          alert(
            'Error: ' + (result.error || 'Failed to fetch customer report'),
          );
        }
      } catch (error) {
        alert('Error fetching customer report: ' + error.message);
      } finally {
        this.customerReport.loading = false;
      }
    },

    exportCustomerReport(format) {
      this.startReportExport('customer', format);
    },

    toggleCustomField(fieldId) {
      const idx = (this.customerReport.filters.custom_field_ids || []).indexOf(
        fieldId,
      );
      if (idx > -1) {
        this.customerReport.filters.custom_field_ids.splice(idx, 1);
      } else {
        (this.customerReport.filters.custom_field_ids =
          this.customerReport.filters.custom_field_ids || []).push(fieldId);
      }
    },

    toggleBookingSelection(bookingId) {
      const booking = this.partnerReport.data.find((b) => b.id === bookingId);
      if (booking && booking.is_invoiced) return;
      const index = this.partnerReport.selectedBookings.indexOf(bookingId);
      if (index > -1) {
        this.partnerReport.selectedBookings.splice(index, 1);
      } else {
        this.partnerReport.selectedBookings.push(bookingId);
      }
    },

    selectAllBookings() {
      this.partnerReport.selectedBookings = this.partnerReport.data
        .filter((b) => !b.is_invoiced)
        .map((b) => b.id);
    },

    toggleSelectAll() {
      const uninvoiced = this.partnerReport.data.filter((b) => !b.is_invoiced);
      const allSelected =
        this.partnerReport.selectedBookings.length === uninvoiced.length &&
        uninvoiced.length > 0;
      this.partnerReport.selectedBookings = allSelected
        ? []
        : uninvoiced.map((b) => b.id);
    },

    getSelectedPartner() {
      if (!this.partnerReport.filters.partner_id) return null;

      const firstBooking = this.partnerReport.data.find(
        (b) => b.partner_id === this.partnerReport.filters.partner_id,
      );
      if (firstBooking) {
        return {
          id: this.partnerReport.filters.partner_id,
          name: firstBooking.partner_name || 'Unknown Partner',
          invoicing_mode: firstBooking.partner_invoicing_mode || null,
        };
      }

      const partnerSelects = document.querySelectorAll('select.form-select');
      for (let i = 0; i < partnerSelects.length; i += 1) {
        const sel = partnerSelects[i];
        if (
          sel.getAttribute('x-model') === 'partnerReport.filters.partner_id' &&
          sel.selectedIndex > 0
        ) {
          return {
            id: this.partnerReport.filters.partner_id,
            name: sel.options[sel.selectedIndex].text,
            invoicing_mode: null,
          };
        }
      }

      return {
        id: this.partnerReport.filters.partner_id,
        name: 'Selected Partner',
        invoicing_mode: null,
      };
    },

    getPartnerSourceCode() {
      return this.partnerReport.data.length > 0
        ? this.partnerReport.data[0].partner_booking_source_code || ''
        : '';
    },

    hasPartnerInvoicingActive() {
      const partner = this.getSelectedPartner();
      return partner && partner.invoicing_mode === 'PARTNER';
    },

    async createBulkInvoice() {
      if (!this.partnerReport.filters.partner_id) {
        alert('Please select a partner first');
        return;
      }
      if (this.partnerReport.selectedBookings.length === 0) {
        alert('Please select at least one booking');
        return;
      }

      const partner = this.getSelectedPartner();
      const partnerName = partner ? partner.name : 'this partner';
      const bookingCount = this.partnerReport.selectedBookings.length;
      if (
        !confirm(
          `Create partner invoice bundle for ${partnerName}?\n\nThis will create ${bookingCount} individual invoice${
            bookingCount > 1 ? 's' : ''
          } and generate a downloadable bundle.`,
        )
      ) {
        return;
      }

      try {
        const response = await fetch('/reports/api/bulk-invoice/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.getCsrfToken(),
          },
          body: JSON.stringify({
            booking_ids: this.partnerReport.selectedBookings,
            invoice_type: this.partnerReport.invoiceType || 'simple',
          }),
        });
        const result = await response.json();
        if (response.ok && result.task_id) {
          this.partnerReport.bulkInvoiceTaskId = result.task_id;
          if (result.invoice_type) {
            this.partnerReport.invoiceType = result.invoice_type;
          }
          this.partnerReport.selectedBookings = [];
          this.fetchPartnerReport();
          this.pollBulkInvoiceStatus(result.task_id);
        } else {
          alert(
            'Error: ' +
              (result.error || 'Failed to create partner invoice bundle'),
          );
        }
      } catch (error) {
        alert('Error creating partner invoice bundle: ' + error.message);
      }
    },

    async pollBulkInvoiceStatus(taskId) {
      const maxAttempts = 120;
      let attempts = 0;

      const checkStatus = async () => {
        try {
          const response = await fetch(`/invoicexpress/task-status/${taskId}/`);
          const data = await response.json();

          if (data.status === 'completed') {
            if (data.success && data.bundle_task_id) {
              this.partnerReport.bundleTaskId = data.bundle_task_id;
              this.pollBundleStatus(data.bundle_task_id);
            } else {
              alert(
                'Invoice creation completed with errors: ' +
                  (data.error || 'Unknown error'),
              );
            }
            this.partnerReport.bulkInvoiceTaskId = null;
            this.fetchPartnerReport();
            return;
          }

          if (data.status === 'failed') {
            alert(
              'Invoice creation failed: ' + (data.error || 'Unknown error'),
            );
            this.partnerReport.bulkInvoiceTaskId = null;
            return;
          }

          attempts += 1;
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          } else {
            alert(
              'Invoice creation is taking longer than expected. Please check back later.',
            );
            this.partnerReport.bulkInvoiceTaskId = null;
          }
        } catch (error) {
          console.error('Error polling bulk invoice status:', error);
          attempts += 1;
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          }
        }
      };

      checkStatus();
    },

    async pollBundleStatus(taskId) {
      const maxAttempts = 240;
      let attempts = 0;

      const checkStatus = async () => {
        try {
          const response = await fetch(`/invoicexpress/task-status/${taskId}/`);
          const data = await response.json();
          this.partnerReport.bundleStatus = data;

          if (data.status === 'completed') {
            if (data.success) {
              this.partnerReport.bundleStatus = data;
              this.fetchPartnerReport();
            } else {
              alert(
                'Bundle generation failed: ' + (data.error || 'Unknown error'),
              );
              this.partnerReport.bundleStatus = null;
            }

            if (this.partnerReport.bundlePollingInterval) {
              clearInterval(this.partnerReport.bundlePollingInterval);
              this.partnerReport.bundlePollingInterval = null;
            }
            return;
          }

          if (data.status === 'failed') {
            alert(
              'Bundle generation failed: ' + (data.error || 'Unknown error'),
            );
            this.partnerReport.bundleStatus = null;
            if (this.partnerReport.bundlePollingInterval) {
              clearInterval(this.partnerReport.bundlePollingInterval);
              this.partnerReport.bundlePollingInterval = null;
            }
            return;
          }

          attempts += 1;
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          } else {
            alert(
              'Bundle generation is taking longer than expected. Please check back later.',
            );
            this.partnerReport.bundleStatus = null;
            if (this.partnerReport.bundlePollingInterval) {
              clearInterval(this.partnerReport.bundlePollingInterval);
              this.partnerReport.bundlePollingInterval = null;
            }
          }
        } catch (error) {
          console.error('Error polling bundle status:', error);
          attempts += 1;
          if (attempts < maxAttempts) {
            setTimeout(checkStatus, 5000);
          }
        }
      };

      checkStatus();
    },

    downloadBundle() {
      if (!this.partnerReport.bundleTaskId) {
        alert('No bundle available for download');
        return;
      }
      const invoiceType = this.partnerReport.invoiceType || 'simple';
      window.location.href = `/reports/api/bulk-invoice-bundle/${this.partnerReport.bundleTaskId}/?invoice_type=${invoiceType}`;
    },

    reportsFormatCurrency(amount, currency) {
      if (amount === null || amount === undefined || amount === '')
        return '€0.00';
      const numAmount = parseFloat(amount);
      if (Number.isNaN(numAmount)) return '€0.00';
      const symbol =
        currency === 'EUR' ? '€' : currency === 'USD' ? '$' : currency;
      return symbol + numAmount.toFixed(2);
    },

    reportsFormatDate(dateStr) {
      if (!dateStr) return '';
      const date = parseDate(dateStr);
      if (!date) return dateStr;
      return date.toLocaleDateString('en-GB');
    },

    reportsStatusDisplay(status) {
      return this.reportsSTATUS_DISPLAY[status] || status || '-';
    },

    formatCurrency(amount, currency) {
      return this.reportsFormatCurrency(amount, currency);
    },

    formatDate(dateStr) {
      return this.reportsFormatDate(dateStr);
    },

    statusDisplay(status) {
      return this.reportsStatusDisplay(status);
    },
  });
}
